import React, { type FC } from 'react'
import { CardMedia, SvgIcon, type SvgIconProps } from '@mui/material'

import type { CybusCatalogApplication } from '../../../../domain'

import type { BaseCommonProps } from '../../common'

const DefaultServiceIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.438 50.449" {...props}>
        <path
            fill="#2291B2"
            d="M23.742,43.507l-0.031-13.789l-11.867-6.914L0,29.695l0.027,13.894l11.817,6.86L23.742,43.507z M13.051,46.968l0.019-9.652l8.25-4.816l0.02,9.629L13.051,46.968z M11.844,25.582l8.289,4.828l-8.262,4.828l-8.289-4.852 L11.844,25.582z M2.406,32.48l8.266,4.836l-0.024,9.664l-8.222-4.773L2.406,32.48z M2.406,32.48"
        />
        <path
            fill="#2291B2"
            d="M38.539,22.804l-11.844,6.891l0.032,13.894l11.816,6.86l11.895-6.942l-0.032-13.789L38.539,22.804z M38.539,25.582l8.289,4.828l-8.262,4.828l-8.289-4.852L38.539,25.582z M29.102,32.48l8.261,4.836l-0.019,9.664l-8.223-4.773 L29.102,32.48z M39.746,46.968l0.02-9.652l8.25-4.816l0.019,9.629L39.746,46.968z M39.746,46.968"
        />
        <path
            fill="#2291B2"
            d="M37.086,6.914L25.219,0L13.375,6.89l0.027,13.895l11.817,6.859l11.898-6.941L37.086,6.914z M25.219,2.777l8.289,4.828l-8.262,4.828l-8.289-4.851L25.219,2.777z M15.781,9.675l8.262,4.836l-0.02,9.664l-8.222-4.773 L15.781,9.675z M26.422,24.164l0.023-9.653l8.246-4.82l0.024,9.633L26.422,24.164z M26.422,24.164"
        />
    </SvgIcon>
)

export const ServiceCardMedia: FC<Pick<CybusCatalogApplication, 'icon' | 'name'> & Pick<BaseCommonProps, 'sx'>> = ({ icon, name, ...props }) =>
    icon ? (
        <CardMedia {...props} component="img" src={icon} title={name} />
    ) : (
        <CardMedia {...props} title={name}>
            <DefaultServiceIcon />
        </CardMedia>
    )
